import { useEffect, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import { Link, useParams } from 'react-router-dom';
import RecapCard from '../../components/booking/RecapCard';
import { useSelector } from "react-redux";
import Loader from '../../components/Loader';
import Error from '../../components/Error';
import { useTranslation } from 'react-i18next';

const SendRequest = () => {
    const { t } = useTranslation();

    // Fetch dati attività
    const [activityData, setActivityData] = useState(null);
    const [isLoadgin, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { activityId } = useParams();
    const token = localStorage.getItem('ticino-wild-token');
    useEffect(() => {
        if (activityId) {
            getActivity();
        }
    }, [activityId])
    const getActivity = async () => {
        try {
            const url = `${process.env.REACT_APP_SERVER_BASE_URL}/activities/get-activity-user/${activityId}`;
            const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
            const options = { method: 'GET', headers };
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setActivityData(result.payload);
            } else {
                const errorData = await response.json();
                const errorMessage = errorData?.message || "Errore sconosciuto dal server";
                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error("Errore durante il fetch:", error);
        }
    }

    // Imposto i dati della richiesta da mandare al server alla conferma
    const [requestData, setRequestData] = useState({
        activityId: null,
        pickerId: null,
        companyId: null,
        bundleId: null,
        people: null
    });

    // Aggiorno i dati della richiesta al completamento della fetch iniziale dei dati dell'attività
    const pickerId = useSelector(state => state.user.id)
    useEffect(() => {
        if (activityData) {
            setRequestData(prevState => ({
                ...prevState,
                activityId: activityData._id,
                pickerId,
                companyId: activityData.company
            }))
        }
    }, [activityData])

    // INVIO RICHIESTA
    const [sendRequestStatus, setSendRequestStatus] = useState('idle');
    const [sendRequestError, setSendRequestError] = useState(null);
    const sendRequest = async () => {
        setSendRequestStatus('loading');
        const token = localStorage.getItem('ticino-wild-token');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/requests/create-new-request`;
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
        const options = { method: 'POST', headers, body: JSON.stringify(requestData) };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                const result = await response.json();
                setSendRequestStatus('succeeded');
            } else {
                const error = await response.json();
                throw new Error("Errore nell'invio della richiesta: ", error.message);
            }
        } catch (error) {
            console.error(error);
            setSendRequestError(error);
            setSendRequestStatus('error');
        }
    }

    // Gestisco il form di inserimento dati partecipanti
    // Esso viene inizializzato da RecapCard
    const [peopleData, setPeopleData] = useState(null)
    const handleSetPeopleData = (event) => {
        const { id, value } = event.target;
        const index = id.split('-')[1];
        const field = id.split('-')[0];
        setPeopleData(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                [`user-${index}`]: {
                    ...prevState.data[`user-${index}`],
                    [field]: value
                }
            }
        }))
    }
    // Quando peopleData avrà tutti i campi compilati, aggiornerà requestData
    // A quel punto comparirà il button di invio
    useEffect(() => {
        console.log('peopleData: ', peopleData)
        if (peopleData && peopleData.data) {
            const dataAmount = peopleData.amount;
            let checkedAmount = 0;
            for (let element in peopleData.data) {
                if (peopleData.data[element].name && peopleData.data[element].surname && peopleData.data[element].birthdate) {
                    checkedAmount++
                }
            };
            // Aggiorno requestData alla voce people. Se i campi non sono tutti compilati essa sarà null
            setRequestData(prevState => ({
                ...prevState,
                people: checkedAmount === dataAmount ? peopleData : null
            }))
        }
    }, [peopleData])

    // Faccio un ulteriore verifica ai dati di acquisto dell'utente nel caso sia atterrato su questa pagina manualmente.
    // Se i dati non sono impostati lo rimando a setUserData
    const { isUserPurchaseAvailable } = useSelector(state => state.user);
    useEffect(() => {
        if (!isUserPurchaseAvailable) window.location.href = "/set-user-data"
    }, [isUserPurchaseAvailable])

    return (
        <PageContainer items="center">
            {
                activityData && sendRequestStatus === 'idle' &&
                <RecapCard
                    photo={activityData.coverImageUrl.resizedUrl}
                    title={activityData.title}
                    summary={activityData.summary}
                    price={activityData.price}
                    priceNote={activityData.priceNote}
                    bundleSelected={requestData.bundleId}
                    setRequestData={setRequestData}
                    setPeopleData={setPeopleData}
                />
            }

            <div className='mt-8'>
                {
                    requestData &&
                    requestData.activityId &&
                    requestData.bundleId &&
                    requestData.companyId &&
                    requestData.pickerId &&
                    sendRequestStatus === 'idle' &&
                    <div className='w-full flex flex-col items-center gap-4'>
                        <h3>{t('SendRequest.setPeopleAmount')}</h3>
                        {
                            peopleData.amount && (() => {
                                const elements = [];
                                for (let i = 0; i < peopleData.amount; i++) {
                                    elements.push(
                                        <div key={i} className='flex flex-col gap-2 p-4 border-2 rounded-xl'>
                                            <label htmlFor="person">{t('SendRequest.peopleNumber')} {i + 1}</label>
                                            <div className='flex flex-col md:flex-row gap-2'>
                                                <div className='flex flex-col'>
                                                    <label className='text-xs text-neutral-500' htmlFor={`name-${i}`}>{t('SendRequest.name')}</label>
                                                    <input type="text" id={`name-${i}`} onChange={handleSetPeopleData} value={peopleData.data[`user-${i}`].name} />
                                                </div>
                                                <div className='flex flex-col'>
                                                    <label className='text-xs text-neutral-500' htmlFor={`surname-${i}`}>{t('SendRequest.surname')}</label>
                                                    <input type="text" id={`surname-${i}`} onChange={handleSetPeopleData} value={peopleData.data[`user-${i}`].surname} />
                                                </div>
                                                <div className='flex flex-col'>
                                                    <label className='text-xs text-neutral-500' htmlFor={`birthdate-${i}`}>{t('SendRequest.birthdate')}</label>
                                                    <input type="date" id={`birthdate-${i}`} onChange={handleSetPeopleData} value={peopleData.data[`user-${i}`].birthdate} />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                return elements
                            })()
                        }
                    </div>
                }
                {
                    requestData &&
                    requestData.activityId &&
                    requestData.bundleId &&
                    requestData.companyId &&
                    requestData.pickerId &&
                    requestData.people &&
                    sendRequestStatus === 'idle' &&
                    <button className="bg-[#225424] py-3 px-6 text-white rounded-xl w-full md:w-fit mt-16" onClick={sendRequest}>
                        Acquista questa esperienza!
                    </button>
                }
                {
                    sendRequestStatus === 'loading' &&
                    <Loader />
                }
                {
                    sendRequestStatus === 'error' &&
                    sendRequestError &&
                    <Error message={sendRequestError.message} />
                }
                {
                    sendRequestStatus === 'succeeded' &&
                    <div>

                        <h3 className='text-[#225424]'>Grazie! Richiesta inviata con successo!</h3>
                        <p>Ti è stata inviata un'email col resoconto dei dati dell'esperienza e le istruzioni per proseguire con l'acquisto.</p>
                        <p>Puoi monitorare lo stato della richiesta nella tua pagina profilo alla sezione "Le tue richieste"</p>
                        <Link to="/my-profile"><button className="bg-[#225424] py-3 px-6 text-white rounded-xl w-full md:w-fit mt-16">Vai al mio profilo</button></Link>
                    </div>
                }
            </div>


        </PageContainer>
    )
}

export default SendRequest